import gql from 'graphql-tag'

export const QueryGetUserInfo = gql(`query userInfo {
    getUserInfo {
      user_id
      nickname
      name
      email
      email_verified
      picture
      scopes
    }
  }`)



// WEBPACK FOOTER //
// ./src/graphql/QueryGetUserInfo.js